class DrawerCartInvoice extends HTMLElement {
  constructor() {
    super();
    this.triggers = [
      this.querySelector(".company-invoice-trigger"),
      this.querySelector(".giftnote__body__close"),
      this.querySelector(".giftnote__overlay"),
    ];
    this.saveBtn = this.querySelector(".giftnote__save");
    this.inputs = this.querySelectorAll(".company-invoice-input");

    this.addEventListener(
      "change",
      debounce((event) => {
        if (event.target.classList.contains("company-invoice-input")) {
          this.updateCartAttributes();
        }
      }, ON_CHANGE_DEBOUNCE_TIMER),
    );
    this.onToggle.bind(this);
  }
  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, textarea, [tabindex]";
    const focusableElements = () =>
      Array.from(
        this.querySelector(".giftnote__body").querySelectorAll(
          focusableElementsSelector,
        ),
      );
    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }
  connectedCallback() {
    this.init();
  }
  updateCartAttributes() {
    const attributes = {};
    this.inputs.forEach(input => {
      const attributeKey = input.getAttribute('name').replace('attributes[', '').replace(']', '');
      attributes[attributeKey] = input.value;
    });

    const body = JSON.stringify({
      attributes: attributes
    });

    fetch(`${routes.cart_update_url}`, { 
      ...fetchConfig(), 
      ...{ body } 
    });
  }
  onSave() {
    this.updateCartAttributes();
    this.onToggle();
  }
  onToggle() {
    const { focusableElements } = this.getFocusableElements();

    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(focusableElements(), "-1");
      this.triggers[0].focus();
    } else {
      this.setAttribute("open", true);
      setTabindex(focusableElements(), "0");
      this.triggers[1].focus();
    }
  }
  init() {
    this.triggers.forEach((trigger) => {
      trigger?.addEventListener("click", (e) => {
        e.preventDefault();
        this.onToggle();
      });
    });

    this.saveBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.onSave();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.hasAttribute("open")) {
          this.onToggle();
        }
      }
      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }
}

customElements.define("drawer-cart-invoice", DrawerCartInvoice);